import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-department",
  "use": "icon-department-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-department\"><path d=\"M576 682.666667H640v128h-213.333333v-128h64v-128H298.666667v128h42.666666v128H170.666667v-128h42.666666v-213.333334h277.333334V341.333333H426.666667V213.333333h213.333333v128h-64v128H853.333333v213.333334h42.666667v128h-170.666667v-128h42.666667v-128h-192v128z\" fill=\"#ffffff\" p-id=\"8679\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol